import React from "react";
import styles from "./index.module.scss";
import SkeletonC from "../../stories/common/skeleton";

const ListHeaderSkeleton = () => {
  return (
    <>
      <div className={styles.ListHeader}>
        <SkeletonC width="218px" height="32px" />
        <div className={styles.Count}>
          <SkeletonC width="37px" height="37px" />
        </div>
      </div>
    </>
  );
};

export default ListHeaderSkeleton;
